export default "__VITE_ASSET__A9A0QbJf__"